export const planetChartData = {
  type: 'bar',
  data: {
    labels: ['FAI', 'VHG', 'TLA', 'OTROS'],
    datasets: [
      { // one line graph
        label: "PTI´s enviados por clínica convencional",
        data: [31, 20, 49, .9],
        backgroundColor: [
          'rgb(16, 64, 111)',
          'rgb(20, 79, 136)',
          'rgb(24, 93, 160)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)',
          'rgb(16, 64, 111)',
          'rgb(20, 79, 136)',
          'rgb(24, 93, 160)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)',
          'rgb(16, 64, 111)',
          'rgb(20, 79, 136)',
          'rgb(24, 93, 160)',
          'rgb(27, 107, 185)',
          'rgb(31, 122, 210)',
          'rgb(45, 136, 224)',
          'rgb(70, 150, 228)',
          'rgb(95, 164, 231)',
          'rgb(119, 178, 235)',
          'rgb(144, 192, 239)',
          'rgb(169, 206, 242)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      }
    ]
  },
  options: {
    responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {

          min: 0,
          beginAtZero: true
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        }
      }]
    }
  }
}

export default planetChartData;